import type { ConsentCategory } from './consent';

/**
 * Every cookie and storage entry the site and game set, by category. The
 * preferences dialog lists these; a new cookie or script lands here first,
 * under the category it needs consent for. `key` is an i18n key suffix:
 * `consent.items.<key>.purpose` / `.duration`.
 */
export interface CookieEntry {
  name: string;
  kind: 'cookie' | 'local' | 'session';
  key: string;
}

export const COOKIE_TABLE: Record<ConsentCategory, CookieEntry[]> = {
  necessary: [
    { name: 'gamer_id', kind: 'cookie', key: 'access' },
    { name: 'refreshToken', kind: 'cookie', key: 'refresh' },
    { name: 'admiralty.session', kind: 'local', key: 'session' },
    { name: 'admiralty.consent.v1', kind: 'local', key: 'consent' },
    { name: 'payments:pendingOrderId', kind: 'session', key: 'payment' },
  ],
  preferences: [
    { name: 'admiralty.settings.v1', kind: 'local', key: 'settings' },
    { name: 'admiralty.locale', kind: 'local', key: 'locale' },
    { name: 'landing.sound', kind: 'local', key: 'sound' },
    { name: 'admiralty.tree.howto.hidden', kind: 'local', key: 'howto' },
  ],
  analytics: [],
  marketing: [],
};
